// extracted by mini-css-extract-plugin
export default {"stars":"ProductSkeleton_stars__vfQwQ"};